// 路由常量(集中,避免字符串 typo)
export const ROUTES = {
  // 默认主页(统计仪表盘)
  home: '/',
  // 公开
  explore: '/explore',
  login: '/login',
  register: '/register',
  // OAuth2 标准授权码流程的 IdP 回跳落地页
  oauthCallback: '/oauth/callback',
  // 需登录
  dashboard: '/dashboard',
  settings: '/settings',
  // admin 专用
  adminUsers: '/admin/users',
  adminRepos: '/admin/repos',
  adminBackups: '/admin/backups',
  adminSettings: '/admin/settings',
  // fallback
  notFound: '/404',
} as const;

export const DEFAULT_REDIRECT_AFTER_LOGIN = '/';
